import { createSelector } from '@reduxjs/toolkit';
import { AlertState } from './alertReducer';
import { DEFAULT_PERSIST_STATE_SCOPE, PersistState } from './persistStateReducer';

export const selectAlert = (state: { _ortkAlert: AlertState }) => {
    const alertState = state._ortkAlert;

    if (!alertState) {
        throw new Error(
            'Alert state not found. Did you include `alertReducer` as `_ortkAlert` when creating root reducer?',
        );
    }

    return alertState as AlertState;
};

export const selectPersistState = createSelector(
    (state: { _ortkPersistState: PersistState }) => {
        const persistState = state._ortkPersistState;

        if (!persistState) {
            throw new Error(
                'Persist state not found. Did you include `persistStateReducer` as `_ortkPersistState` when creating root reducer?',
            );
        }

        return persistState as PersistState;
    },
    (
        _state: unknown,
        props: {
            key: string;
            scope?: string;
        },
    ) => props,
    (persistState, { key, scope }) => {
        const scopeKey = scope ?? DEFAULT_PERSIST_STATE_SCOPE;
        const scopeData = persistState[scopeKey] as Record<string, unknown> | undefined;
        if (!scopeData || !key) return undefined;
        return scopeData[key];
    },
);
